/* eslint-disable no-unused-vars */
import React from 'react';
import {
    Label
} from 'shared/components/ui/label';
import {
    FileText
} from 'lucide-react';
import LongTextField from '../../primitives/LongTextField';

/**
 * InstructionsSection — Default Instruction inline strings (UF-2).
 * Holds system_prompt / guidelines / content_policy directly on the
 * assistant doc; not refs to Library Instructions.
 */
export default function InstructionsSection({
    a, onPatch
}) {
    const ins = a.instructions || {};
    const setIns = (k, v) => onPatch({
        instructions: {
            ...ins,
            [k]: v
        }
    });
    return (
        <div className="space-y-3">
            <div>
                <Label>System Prompt</Label>
                <LongTextField
                    label="System Prompt"
                    value={ins.system_prompt || ''}
                    onChange={(v) => setIns('system_prompt', v)}
                    placeholder="You are…"
                    helpText="Inline string. This employee’s identity (system prompt, persona, guidelines, content policy) is added to the start of every instruction prompt automatically when it runs — no token in the prompt is needed."
                />
            </div>
            <div>
                <Label>Guidelines</Label>
                <LongTextField
                    label="Guidelines"
                    value={ins.guidelines || ''}
                    onChange={(v) => setIns('guidelines', v)}
                />
            </div>
            <div>
                <Label>Content Policy</Label>
                <LongTextField
                    label="Content Policy"
                    value={ins.content_policy || ''}
                    onChange={(v) => setIns('content_policy', v)}
                />
            </div>
        </div>
    );
}
